module.exports = __webpack_public_path__ + "img/embedded5.9ea75044.png";